export const formatTime = (isoString: string, format: 'HH:mm' | 'full' = 'full'): string => {
  const date = new Date(isoString);
  if (format === 'HH:mm') {
    return date.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit', hour12: false });
  }
  return date.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' });
};

export const formatMinuterFør = (item: { er_relativ: boolean; minutter_for_start: number }): string => {
  if (!item.er_relativ) {
    return 'Fast tid';
  }
  
  const minutes = item.minutter_for_start;
  if (minutes > 0) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0) {
      return `${hours}:${mins.toString().padStart(2, '0')} før start`;
    }
    return `${minutes} min før start`;
  }
  return 'Ved start';
};

